import { render, staticRenderFns } from "./ColorSelectorBtn.vue?vue&type=template&id=4dcb248f&"
import script from "./ColorSelectorBtn.vue?vue&type=script&lang=js&"
export * from "./ColorSelectorBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports